import styled from 'styled-components';

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const ButtonSaveContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.sm} 0
    ${({ theme }) => theme.spacing.md} 0;
`;
